import React from 'react';
import {
  MUTATION_REMOVE_SESSION,
  S_QUERY_GET_SESSIONS_BY_ENTITY_ID,
  QUERY_GET_SESSIONS_OF_PERSON
} from 'services/aws/session-query';
import Icon from 'components/icon/Icon';
import ConfirmMutationButton from './ConfirmMutationButton';
import messages from 'messages';

const RemoveSessionButton = ({
  entityId,
  sessionId,
  children,
  onComplete,
  personId,
  dataQa,
  ...props
}) => {
  let refetchQueries = [
    {
      query: S_QUERY_GET_SESSIONS_BY_ENTITY_ID,
      variables: { entityId }
    }
  ];
  if (personId) {
    refetchQueries = [
      {
        query: QUERY_GET_SESSIONS_OF_PERSON,
        variables: { personId: personId, entityId }
      }
    ];
  }
  return (
    <ConfirmMutationButton
      {...props}
      mutation={MUTATION_REMOVE_SESSION}
      refetchQueries={refetchQueries}
      confirmTitle={messages.modalConfirmRemoveSessionTitle}
      confirmMessage={messages.modalConfirmRemoveSessionMessage}
      variables={{
        testSessionId: sessionId
      }}
      update={(cache, { data: { archiveTestSession } }) => {
        if (archiveTestSession) {
          if (onComplete) onComplete();
        }
      }}
      dataQa={dataQa}
    >
      <Icon id="delete" />
      {children}
    </ConfirmMutationButton>
  );
};

export default RemoveSessionButton;
